import axios from 'axios'

export const all = (): Promise<any> => {
  return axios.get('notifications')
}

export const destroy = (id: number): Promise<any> => {
  return axios.delete(`notifications/${id}`)
}
